<template>
  <transition name='fade'>
    <div
      class="modal headimg_box"
      v-if='visible'
    >
      <div
        class="headimg"
        v-loading='sendLoading'
        element-loading-text="提交中,请稍后"
      >
        <div class="title msp_icon_close">
          <span class="title_name">投递文章</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <div class="submitarticle">
          <div class="submit_article_each">
            <div
              class="title"
              style="display:flex;"
            >
              <span style="margin-right:10px;">单位选择</span>
              <el-input
                v-model="unitInput"
                placeholder="请输入内容"
                @input="unitInputChange"
              ></el-input>
            </div>
            <div class="submit_article_list">
              <div
                class="submit_article_unit"
                :class="[currentUnitId === item.compid ? 'submit_article_unit_active':'']"
                v-for="(item,index) in submitArticleUnitList"
                :key="index"
                @click.stop="getUnitFolder(item)"
              >
                <span>{{item.compname}}</span>
              </div>
            </div>
          </div>
          <div class="submit_article_each">
            <div class="title">
              文件夹选择
            </div>
            <div class="submit_article_list masp_repo_tree">
              <el-tree
                :data="submitArticleFolderTree"
                :props="defaultProps"
                :default-expand-all='true'
                @node-click="handleNodeClick"
                :highlight-current='true'
                element-loading-text="拼命加载中"
                :expand-on-click-node='true'
                node-key="id"
                :show-checkbox='true'
                :check-on-click-node='false'
                ref='submitArticleFolderTreeRef'
                :check-strictly='true'
                v-loading="folderTreeLoading"
                @check-change='checkChange'
              >
                <span
                  class="custom-tree-node"
                  slot-scope="{ node, data }"
                >

                  <span
                    class="node_label"
                    :title="node.label"
                  >{{ node.label }}</span>

                  <span
                    class="el-iconfont el-icon-arrow-right"
                    v-if='data.children && data.children.hasOwnProperty("length") && data.children.length>0 && !node.expanded'
                  ></span>
                  <span
                    class="el-iconfont el-icon-arrow-down"
                    v-if='data.children && data.children.hasOwnProperty("length") && data.children.length>0 && node.expanded'
                  ></span>

                </span>
              </el-tree>

            </div>

          </div>
          <div
            class="submit_article_each"
            style="margin-right:20px;"
          >
            <div class="title">
              已选投递地址
            </div>
            <div class="submit_article_list">
              <div
                class="has_choice_folder"
                v-for="(item,index) in hasChoiceFolderList"
                :key="index"
              >
                <span
                  class="has_choice_folder_left"
                  :title="item.pathValue"
                >{{item.pathValue}}</span>
                <span class="has_choice_folder_right">
                  <span
                    class="el-icon-close"
                    @click.stop="deleteCurrentChoiceFolder(index)"
                  ></span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="headimg_buttom">
          <el-button
            type="primary"
            @click.native='sureAddWaterimg()'
          >确定投递</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'
import logsMixins from '../../../mixins/logs'
export default {
  name: 'submitarticle',
  data () {
    return {
      visible: false,
      submitArticleUnitList: [],
      orgSubmitArticleUnitList: [],
      currentUnitId: '',
      hasChoiceFolderList: [],
      submitArticleList: '',
      submitArticleFolderTree: [],
      sendLoading: false,
      unitInput: '',
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: function (data) {
          if (data.flag_repo) {
            return true
          }
        }
      },
      folderTreeLoading: false
    }
  },
  mixins: [logsMixins],
  mounted () {
    this.$root.eventHub.$on('setSubmitArticleModel', (data) => {
      this.visible = true
      this.submitArticleList = data
      this.getSubmitArticleUnit()
    })


  },
  destroyed () {
    this.$root.eventHub.$off('setSubmitArticleModel')
  },
  components: {

  },
  computed: {

  },
  methods: {
    closeBox () {
      this.visible = false
    },
    getSubmitArticleUnit () {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {          // 必须字段：  参数

        }
      }
      api._post(_API_ + 'api/article/submit/get_company', option).then((resp) => {
        if (resp.code == 200) {
          this.submitArticleUnitList = resp.data
          this.orgSubmitArticleUnitList = JSON.parse(JSON.stringify(resp.data))
        } else {
          this.submitArticleUnitList = []
        }
      }).catch((error) => {
        this.submitArticleUnitList = []
        console.log(error)
      })
    },
    getUnitFolder (item) {
      this.currentUnitId = item.compid
      this.currentUnitName = item.compname
      var option = {
        ...this.$store.getters.baseOption,
        "params": {          // 必须字段：  参数
          'submit_company_id': item.compid
        }
      }
      this.folderTreeLoading = true
      api._post(_REPOSITORYURL_ + 'api/repository/submit/get_repo', option).then((resp) => {
        if (resp.code == 200) {
          this.submitArticleFolderTree = resp.data
          this.$nextTick(function () {
            this.setCurrentChoiceFolderFn()
          })

        } else {
          this.submitArticleFolderTree = []
        }
        this.folderTreeLoading = false
      }).catch((error) => {
        this.submitArticleFolderTree = []
        this.folderTreeLoading = false
        console.log(error)
      })

    },
    setCurrentChoiceFolderFn () {
      var arr = this.$refs.submitArticleFolderTreeRef.getCheckedNodes()
      for (var i = 0; i < arr.length; i++) {
        this.$refs.submitArticleFolderTreeRef.setChecked(arr[i])
      }
      for (var j = 0; j < this.hasChoiceFolderList.length; j++) {
        this.$refs.submitArticleFolderTreeRef.setChecked(this.hasChoiceFolderList[j].id, true)
      }
    },
    getPathById (id, repo_id, node) {
      var temppath = []
      try {
        function getNodePath (node) {
          temppath.push(node.name)
          if (node.id === id) {
            throw ("GOT IT!")
          }
          if (node.children && node.children.length > 0) {
            for (var i = 0; i < node.children.length; i++) {
              getNodePath(node.children[i])
            }
            temppath.pop()
          }
          else {
            temppath.pop()
          }
        }
        getNodePath(node)
      }
      catch (e) {
        console.log(e)
      }

      this.setChoiceCheckFolder(id, repo_id, temppath)

    },
    setChoiceCheckFolder (id, repo_id, arr) {
      var path = ''
      for (var i = 0; i < arr.length; i++) {
        path = path + '--' + arr[i]
      }

      var k = 0
      for (var j = 0; j < this.hasChoiceFolderList.length; j++) {
        if (this.hasChoiceFolderList[j].id !== id) {
          k++
        } else {
          break;
        }
      }

      if (k === this.hasChoiceFolderList.length) {
        this.hasChoiceFolderList.push({
          id: id,
          company_id: this.currentUnitId,
          repo_id: repo_id,
          folder_id: id,
          pathValue: this.currentUnitName + '-' + path.substring(1)
        })
      }

    },
    sureAddWaterimg () {
      var articleIdArr = []
      for (var i = 0; i < this.submitArticleList.length; i++) {
        articleIdArr.push(this.submitArticleList[i].id)
      }
      var option = {
        ...this.$store.getters.baseOption,
        "params": {          // 必须字段：  参数
          article_ids: articleIdArr,
          submit_info: this.hasChoiceFolderList
        }
      }
      if (this.hasChoiceFolderList.length > 0) {
        this.sendLoading = true
        api._post(_API_ + 'api/article/submit/submit_article', option).then((resp) => {
          if (resp.code == 200) {
            this.$notify.success({
              title: '成功',
              message: '投递成功'
            })
            this.getOperateLogs(this.submitArticleList[0].id)

            for (var j = 0; j < this.submitArticleList.length; j++) {
              this.$set(this.submitArticleList[j], 'flag_submit', true)
            }

            this.visible = false
          }
          this.sendLoading = false
        }).catch((error) => {
          console.log(error)
          this.sendLoading = false
        })
      } else {
        this.$notify.warning({
          title: '提示',
          message: '请选择文件夹'
        })
      }
    },
    handleNodeClick () {

    },
    checkChange (data, check) {
      if (!check) {
        for (var j = 0; j < this.hasChoiceFolderList.length; j++) {
          if (this.hasChoiceFolderList[j].id === data.id) {
            this.hasChoiceFolderList.splice(j, 1)
            break;
          }
        }
      } else {
        var currentNode = this.setCurrentFolderPath(data.id_repo)
        this.getPathById(data.id, data.id_repo, currentNode)
      }
    },
    setCurrentFolderPath (repoid) {
      for (var i = 0; i < this.submitArticleFolderTree.length; i++) {
        if (this.submitArticleFolderTree[i].id === repoid) {
          return this.submitArticleFolderTree[i]
        }
      }
    },
    deleteCurrentChoiceFolder (index) {
      this.hasChoiceFolderList.splice(index, 1)
      this.setCurrentChoiceFolderFn()
    },
    unitInputChange () {
      if (this.unitInput) {
        var arr = []
        for (var i = 0; i < this.submitArticleUnitList.length; i++) {
          if (this.submitArticleUnitList[i].compname.indexOf(this.unitInput) !== -1) {
            arr.push(this.submitArticleUnitList[i])
          }
        }
        this.submitArticleUnitList = arr
      } else {
        this.submitArticleUnitList = this.orgSubmitArticleUnitList
      }

    }

  },
  watch: {
    visible () {
      if (!this.visible) {
        this.submitArticleUnitList = []
        this.currentUnitId = ''
        this.hasChoiceFolderList = []
        this.submitArticleList = ''
        this.submitArticleFolderTree = []
        this.unitInput = ''
        this.orgSubmitArticleUnitList = []
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.headimg_box
  .headimg
    position relative
    width 54%
    height 600px
    border-radius 6px
    background #fff

    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      border-bottom 1px solid #E4E7ED

      .title_name
        span-medium-title()
        float left
        line-height 48px

      .iconfont
        float right
        font-size 22px
        line-height 48px
        cursor pointer

    .submitarticle
      display flex
      box-sizing border-box
      padding-top 20px
      height calc(100% - 48px)

      .submit_article_each
        box-sizing border-box
        margin-left 20px
        width 31%
        height 84%
        border 1px solid rgba(230, 231, 235, 1)
        background rgba(255, 255, 255, 1)
        box-shadow 0px 0px 1px 0px rgba(0, 0, 0, 0.1)

        .title
          padding-left 14px
          height 48px
          color #606266
          font-size 14px
          line-height 48px

        .submit_article_list
          overflow auto
          width 100%
          height calc(100% - 48px)

          .submit_article_unit
            box-sizing border-box
            padding-left 14px
            height 52px
            cursor pointer

            span
              display inline-block
              overflow hidden
              width 100%
              height 52px
              color #909399
              text-overflow ellipsis
              white-space nowrap
              font-size 14px
              line-height 52px

          .submit_article_unit_active
            background #E5EDFC

          .has_choice_folder
            clear both
            box-sizing border-box
            padding-right 14px
            padding-left 14px
            height 52px

            .has_choice_folder_left
              display inline-block
              float left
              overflow hidden
              width 80%
              color #688EFF
              text-overflow ellipsis
              white-space nowrap
              font-size 14px
              line-height 52px

            .has_choice_folder_right
              display inline-block
              float right
              box-sizing border-box
              padding-top 16px

              span
                width 14px
                height 14px
                border 1px solid #606266
                border-radius 50%
                color #606266
                text-align center
                font-size 14px
                line-height 14px
                cursor pointer

    .headimg_buttom
      position absolute
      bottom 20px
      display flex
      justify-content center
      box-sizing border-box
      padding-right 20px
      width 100%
      border-radius 0 0 6px 6px

      button
        width 74px
        height 28px
        center()
        line-height 0
</style>
